export default "__VITE_ASSET__98e8423a__"